import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {ZoneTileType25} from "../../../models";
import {SubtitlesService} from "../../../core";

@Component({
    selector: 'simple-valve-parameters',
    templateUrl: './simple-valve-parameters.component.html',
    styleUrl: './simple-valve-parameters.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleValveParametersComponent {
    @Input() tile!: ZoneTileType25;

    private subtitlesService = inject(SubtitlesService);

    protected labels = {
        valveNumber:        this.subtitlesService.setSubtitle(973),
        sourceTemp:         this.subtitlesService.setSubtitle(3287),
        currentTemp:        this.subtitlesService.setSubtitle(1162),
        setTemp:            this.subtitlesService.setSubtitle(760),
        openingPercentage:  this.subtitlesService.setSubtitle(1161),
        valvePump:          this.subtitlesService.setSubtitle(585),
        valvePumpOff:       this.subtitlesService.setSubtitle(922),
        valvePumpOn:        this.subtitlesService.setSubtitle(950),
        floorProtection:    this.subtitlesService.setSubtitle(3603),
        version:            this.subtitlesService.setSubtitle(1634),
    };

    get version(): string {
        if (this.tile.params.version == null) return '';
        const v = this.tile.params.version.toString().padStart(8, '0');
        const major = parseInt(v.slice(0, 2), 10);
        const minor = parseInt(v.slice(2, 4), 10);
        const patch = parseInt(v.slice(4), 10);
        return `${major}.${minor}.${patch}`;
    }

    get valvePumpLabel(): string {
        return this.tile.params.valvePump === 0
            ? this.labels.valvePumpOff
            : this.labels.valvePumpOn;
    }
}
